export function FireDownloads() {
  return <div className="tab-content-wrapper">Fire Downloads</div>;
}
